import React from 'react';
import {View} from 'react-native';
import {useFormikContext} from 'formik';

import ErrorMessage from './ErrorMessage';
import AppTextInput from '../AppTextInput';

function AppFormField({name, value, style, login, onChange, ...otherProps}) {
  const {
    setFieldTouched,
    setFieldValue,
    errors,
    touched,
    values,
  } = useFormikContext();

  // setFieldValue(name, value);

  return (
    <View
      style={{
        // flex: 1,
        flexDirection: 'column',
        // marginBottom: errors[name] && touched[name] && login ? -24 : 0,
      }}>
      <AppTextInput
        textStyle={style}
        onBlur={() => setFieldTouched(name)}
        onChangeText={(text) => {
          if (onChange) {
            onChange(name, text);
          }
          setFieldValue(name, text);
        }}
        value={values[name] || value}
        {...otherProps}
      />
      <ErrorMessage
        error={errors[name]}
        visible={touched[name]}
        login={login}
      />
    </View>
  );
}

export default AppFormField;
